import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'demo-upp-scale-input',
    templateUrl: './demo-upp-scale-input.html',
    styleUrls: ['../demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoUppScaleInputComponent {
    form = new FormGroup({
        weight: new FormControl<number | null>(null, [Validators.required]),
    });

    /**
     * Demo stays in manual mode (no live WS). Product callers open the socket
     * and pass `connection` + `device` into the widget.
     */
    connection = null;
    device = null;

    constructor(private change: ChangeDetectorRef) {
    }

    setSampleWeight(): void {
        this.form.patchValue({ weight: 1250 });
        this.form.get('weight')?.markAsDirty();
        this.change.markForCheck();
    }

    resetForm(): void {
        this.form.reset();
        this.change.markForCheck();
    }
}
